import { useMutation } from '@tanstack/react-query';
import { MultipleRateGroupsAddParameters, useRepositoryRegistry } from '@mews-commander/data-access';

export const useRateGroupAddMutation = () => {
    const { rateGroups } = useRepositoryRegistry();

    return useMutation({
        mutationFn: async (parameters: MultipleRateGroupsAddParameters) => rateGroups.add(parameters),
        mutationKey: ['rateGroups', 'add'],
    });
};
